// src/features/fourlink-config/utils/storage/localStorage.js

import { isPlainObject } from '../helpers/filters';
import { STORAGE_KEY } from '../helpers/constants';

export const buildSnapshot = (state) => ({
  currentStep: state.currentStep,
  currentBlock: state.currentBlock,
  selectedTipologias: state.selectedTipologias,
  hiddenEquipos: state.hiddenEquipos,
  hiddenTipologias: state.hiddenTipologias,
  hiddenGruposProfesionales: state.hiddenGruposProfesionales,
  hiddenProfesionalesPorGrupo: state.hiddenProfesionalesPorGrupo,
  customTipologias: state.customTipologias,
  customEquipos: state.customEquipos,
  customPlanes: state.customPlanes,
  hiddenPlanes: state.hiddenPlanes,
  hiddenCategoriasActivos: state.hiddenCategoriasActivos,
  hiddenActivosPorCategoria: state.hiddenActivosPorCategoria,
  hiddenCategoriasTareas: state.hiddenCategoriasTareas,
  hiddenTareasPorCategoria: state.hiddenTareasPorCategoria,
  customCategoriasProfesionales: state.customCategoriasProfesionales,
  customCategoriasActivos: state.customCategoriasActivos,
  customCategoriasTareas: state.customCategoriasTareas,
  centros: state.centros,
  selectedEquipos: state.selectedEquipos,
  equiposConfig: state.equiposConfig,
  selectedCategorias: state.selectedCategorias,
  selectedPlanes: state.selectedPlanes,
  selectedActivos: state.selectedActivos,
  activosConfig: state.activosConfig,
  selectedTareas: state.selectedTareas,
  registrosActivosConfig: state.registrosActivosConfig,
  tareasConfiguracion: state.tareasConfiguracion,
  tareaFotos: state.tareaFotos,
  horariosDisponibles: state.horariosDisponibles,
  newCentroName: state.newCentroName,
  newCentroTipologia: state.newCentroTipologia,
  collapsedCategories: state.collapsedCategories,
  collapsedCategoriasProfesionales: state.collapsedCategoriasProfesionales,
  collapsedCategoriasActivos: state.collapsedCategoriasActivos,
  tipologiaEquipoMatrix: state.tipologiaEquipoMatrix,
  tipologiaActivoMatrix: state.tipologiaActivoMatrix,
  tareasAsignacionMatrix: state.tareasAsignacionMatrix,
  showVisualPreview: state.showVisualPreview,
  comments: state.comments,
  selectedInstance: state.selectedInstance,
});

export const hasMeaningfulSnapshotData = (snapshot) => {
  if (!snapshot || typeof snapshot !== 'object') {
    return false;
  }

  const arrayFields = [
    'selectedTipologias',
    'hiddenEquipos',
    'hiddenTipologias',
    'hiddenPlanes',
    'hiddenCategoriasActivos',
    'hiddenCategoriasTareas',
    'hiddenGruposProfesionales',
    'customTipologias',
    'customEquipos',
    'customPlanes',
    'centros',
    'selectedEquipos',
    'selectedCategorias',
    'selectedPlanes',
    'selectedActivos',
    'selectedTareas',
    'horariosDisponibles',
  ];

  if (arrayFields.some((field) => Array.isArray(snapshot[field]) && snapshot[field].length > 0)) {
    return true;
  }

  const objectFields = [
    'equiposConfig',
    'activosConfig',
    'registrosActivosConfig',
    'tareasConfiguracion',
    'tareaFotos',
    'collapsedCategories',
    'collapsedCategoriasProfesionales',
    'collapsedCategoriasActivos',
    'customCategoriasProfesionales',
    'customCategoriasActivos',
    'customCategoriasTareas',
    'tipologiaEquipoMatrix',
    'tipologiaActivoMatrix',
    'tareasAsignacionMatrix',
    'hiddenProfesionalesPorGrupo',
    'hiddenPlanes',
    'hiddenActivosPorCategoria',
    'hiddenTareasPorCategoria',
    'hiddenCategoriasActivos',
    'comments',
  ];

  if (objectFields.some((field) => isPlainObject(snapshot[field]) && Object.keys(snapshot[field]).length > 0)) {
    return true;
  }

  if (typeof snapshot.newCentroName === 'string' && snapshot.newCentroName.trim()) return true;
  if (typeof snapshot.newCentroTipologia === 'string' && snapshot.newCentroTipologia.trim()) return true;
  if (typeof snapshot.showVisualPreview === 'boolean' && snapshot.showVisualPreview) return true;
  if (typeof snapshot.currentStep === 'number' && snapshot.currentStep > 1) return true;
  if (typeof snapshot.currentBlock === 'number' && snapshot.currentBlock > 1) return true;

  return false;
};

export const saveToLocalStorage = (snapshot) => {
  if (typeof window === 'undefined' || !window.localStorage) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(snapshot));
  } catch (error) {
    console.error('Error saving to localStorage:', error);
  }
};

export const loadFromLocalStorage = () => {
  if (typeof window === 'undefined' || !window.localStorage) return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (error) {
    console.error('Error loading from localStorage:', error);
    return null;
  }
};
